import React from "react";

const brands = [
  "Angel One", "Axis Securities", "Upstox", "Airtel Payments", "Lemonn", "Kotak811",
  "ACKO", "ABCD Health", "TATA AIG", "Muthoot Finance", "Opinion Bureau", "ReSearch360",
  "Bajaj Broking", "HDFC Sky", "Asian Paints", "Zomato", "Coca-Cola", "Pepsi",
  "PlayerzPot", "Dream11", "RummyCircle", "My11Circle", "Winzo", "Zupee",
];

export default function Brands() {
  return (
    <section id="brands" className="relative py-24 bg-[#070707] border-y border-white/5 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 mb-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <span className="eyebrow-emerald">Campaign Experience</span>
            <h2 className="mt-6 text-4xl md:text-5xl font-semibold max-w-2xl leading-tight">
              Trusted by India's <span className="text-gold-gradient">leading brands.</span>
            </h2>
          </div>
          <p className="text-white/55 max-w-md">
            Real campaigns. Real impact. Executed directly and through strategic media & affiliate partnerships.
          </p>
        </div>
      </div>

      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-40 bg-gradient-to-r from-[#070707] to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-40 bg-gradient-to-l from-[#070707] to-transparent z-10" />

        <div className="overflow-hidden">
          <div className="marquee-track flex gap-3 whitespace-nowrap">
            {[...brands, ...brands].map((b, i) => (
              <div
                key={i}
                className="shrink-0 px-6 py-4 rounded-xl border border-white/10 bg-white/[0.02] text-white/75 hover:text-white hover:border-[#C9A227]/40 transition-colors"
              >
                <span className="text-lg tracking-wide">{b}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="overflow-hidden mt-3">
          <div className="marquee-track flex gap-3 whitespace-nowrap" style={{animationDirection:"reverse"}}>
            {[...brands.slice().reverse(), ...brands.slice().reverse()].map((b, i) => (
              <div
                key={i}
                className="shrink-0 px-6 py-4 rounded-xl border border-white/10 bg-white/[0.02] text-white/75 hover:text-white hover:border-[#10B981]/40 transition-colors"
              >
                <span className="text-lg tracking-wide">{b}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 lg:px-8 mt-12 text-center text-white/50 text-sm">
        Presented as verified campaign experience across <span className="text-[#F4D983]">Finance, Insurance, Gaming, FinTech, EdTech, E-commerce</span> and Consumer Brands.
      </div>
    </section>
  );
}
